import React from 'react'

interface Props {
    children?: React.ReactNode
}
const HorizontalCardImageLeftTop: React.FC<Props> = props => {
    return <>{props.children}</>
}

export default HorizontalCardImageLeftTop
